<template>
   <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 :width="`${logHeight}`+'px'" :height="`${logHeight}`+'px'" viewBox="0 0 50 50" enable-background="new 0 0 50 50" xml:space="preserve">
    <g>
        <polygon fill="#EC1C83" points="29.456,23.154 27.42,11.132 15.982,15.355 	"/>
        <path fill="#259CD7" d="M44.343,20.801l-14.407-8.342l2.156,12.568l-19.07,10.982l0.026-22.006L25.02,9.614L10.613,1.272
            C9.099,0.395,7.23,0.393,5.714,1.267c-1.517,0.873-2.454,2.49-2.455,4.239L3.212,44.482c-0.001,1.749,0.93,3.369,2.445,4.247
            c1.515,0.875,3.382,0.878,4.9,0.003l33.777-19.447c1.518-0.875,2.45-2.489,2.453-4.241C46.791,23.295,45.857,21.678,44.343,20.801z
            "/>
    </g>
    </svg>

</template>
<script>
export default {
    props: {
        logHeight: {          
            required: false,
            default: 40
        },
    }
}
</script>
<style lang="scss" scoped>

</style>